export default __webpack_public_path__ + "static/media/FrankGrimes.8f189419.png";